<template>
  <div class="thousand_layout">
    <div>
      <div class="bids_tabs">
        <div @click="HistoryTabs(0)" :class="historyTab==0?'on':''">{{ $t('base.unusedCoupons') }}<span class="text_red" v-if="UnusedCount > 0">&nbsp;({{UnusedCount}})</span></div>
        <div @click="HistoryTabs(1)" :class="historyTab==1?'on':''">{{ $t('base.expiredCoupons') }}</div>
      </div>
      <div class="couponsBox" v-if="!nofind">
        <div class="couponsList" v-for="(item,index) in list" :key="index" :class="historyTab == 1? 'overdue color_aoao':''">
          <div>{{ $t('base.coupons') }}</div>
          <div class="couponCart">
            <div class="couponPrice">
              <div :class="historyTab == 1? 'color_aoao':'text_red'">{{areaSymbol}} {{item.FreeMoney}} {{ $t('base.off') }}</div>
              <!-- <div :class="historyTab == 1? 'color_aoao':'text_red'">Unlimited</div> -->
            </div>
            <div class="couponSpan">
              <span class="">{{ $t('colon.expireTime') }} {{item.EndDate|setTime}}</span>
              <span class="" v-if="item.IsAllUse">{{ $t('alert.allProducts') }}</span>
            </div>
          </div>
        </div>
      </div>
      <list-pagination :TotalCount="TotalCount" :ps="ps" :type='0' @ps='pageSize' @pi='pageIndex' v-if="!nofind" />
      <n-o-t-n class="notfind" title="" :text="$t('base.noData')" type="coupons" v-else-if="resultTpye==1" />
      <f-z-f class="notfind" title="" :text="$t('base.pagefault')" v-else />
    </div>
  </div>
</template>
<script>
import { getTime } from "@/api/public";
import FZF from "@/components/notnull";
import ListPagination from "@/components/listpagination";
import NOTN from "@/components/notnull.vue";

export default {
  name: 'chp',
  components: { FZF, ListPagination, NOTN },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      historyTab: 0,
      pi: 1,
      ps: 12,
      list: '',
      nofind: false,
      tabNumber: '',
      Count: 0,
      UnusedCount:0,
      resultTpye: '',
    }
  },
  filters: {
    setTime(val) {
      //console.log(getTime(val, -8, '', 'cn'))
      //return getTime(val, -8, '', 'cn')
      return getTime(val, -8, '', 'cn')
    }
  },
  props: {
    userInfo: {}
  },
  created() {
    this.GetMyCoupon()
  },
  mounted() { },
  methods: {
    HistoryTabs(val) {
      this.historyTab = val;
      this.list = ''
      this.GetMyCoupon();
    },
    //获取优惠券列表
    GetMyCoupon() {
      let that = this;
      let data = { operator_id: this.userInfo.MappingUserId, memberid: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken, pageIndex: this.pi, pageSize: this.ps, type: this.historyTab, }
      this.$get(this.$interface.MyCoupon, data).then(res => {
        if (res.Result != 0) {
          this.list = res.Data;
          this.TotalCount = res.Count;
          this.UnusedCount=this.historyTab==0?res.Count:this.UnusedCount;
          this.nofind = false
          if (res.Count > 0) {
            this.nofind = false
          } else {
            this.nofind = true
          }
        } else {
          this.nofind = true
        }
        that.resultTpye = res.Result
      })
    },

    // 每页几条
    pageSize(val) {
      this.ps = val
      this.GetMyCoupon();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.GetMyCoupon();
    },

  }
}

</script>
<style scoped>
@import "../../../static/css/usertabslist.css";
.couponsBox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 40px;
}

.couponsList {
  display: flex;
  width: 430px;
  height: 120px;
  font-size: 16px;
  margin-bottom: 30px;
  background: url(../../../static/images/couponsbg.svg) no-repeat;
}

.couponsList > div:first-child {
  width: 128px;
  height: 120px;
  background: url(../../../static/images/coupons.svg) no-repeat;
  background-position: center 35%;
  background-size: 50% auto;
  text-align: center;
  color: #fff;
  line-height: 190px;
}

.couponsList > .couponCart {
  width: 302px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0px 5px 30px 1px rgba(0, 0, 0, 0.01),
    0px 4px 10px 1px rgba(0, 0, 0, 0.01), 0px 1px 4px 1px rgba(0, 0, 0, 0.01);
}

.couponsList .couponPrice {
  font-size: 20px;
  font-weight: bold;
  line-height: 1.3;
  padding-top: 5px;
}

.couponsList .couponPrice > div:last-child {
  font-size: 16px;
  font-weight: normal;
}

.couponsList .couponSpan > span {
  display: block;
  position: relative;
  padding-left: 8px;
  font-size: 14px;
}

.couponsList .couponSpan > span:first-child {
  margin-bottom: 3px;
}

.couponsList .couponSpan > span:before {
  content: "";
  position: absolute;
  width: 3px;
  height: 3px;
  background-color: #333;
  border-radius: 10px;
  top: 6px;
  left: 0;
}
.overdue {
  background: url(../../../static/images/overdue.svg) no-repeat;
}
.couponsList.overdue .couponSpan > span:before {
  background-color: #a0a0a0;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/coupons.vue